<template>
  <app-filters-drawer :model-value="isOpen" :title="$t('project.signed-documents.pane.SignedDocumentsFiltersPane.filters')"
                      data-locator="signed-documents-filters-pane"
                      @close="onCloseRequest" @clear="resetFilters" @apply="closePane"
  >
    <template #body>
      <div class="text-body-1 font-weight-bold text-text-primary mb-4">
        {{ $t('project.signed-documents.pane.SignedDocumentsFiltersPane.dates') }}
      </div>
      <AppDateRangePicker
        :model-value="datesFilter"
        :label="$t('project.signed-documents.pane.SignedDocumentsFiltersPane.inputSignDateLabel')"
        @update:model-value="handleDatesFilterChange"
      />

      <template v-if="signatories.length > 0">
        <v-divider class="my-6"/>

        <div class="text-body-1 font-weight-bold text-text-primary">
          {{ $t('project.signed-documents.pane.SignedDocumentsFiltersPane.signatories') }}
        </div>
        <v-row no-gutters>
          <v-col
            v-for="signatory in signatories.length > 10 && !displayMoreSignatories ? shortSignatories : signatories"
            :key="`signatory-${signatory.signerId}`"
            class="py-1"
            cols="12"
            md="6"
          >
            <v-checkbox :model-value="filters.signatories"
                        :label="signatory.fullName"
                        density="compact"
                        hide-details
                        class="SignedDocumentsFiltersPane-checkbox my-1 py-0"
                        :value="signatory.signerId"
                        @update:model-value="setFiltersSignatories($event)"
            />
          </v-col>
        </v-row>

        <h4 v-if="signatories.length > 10 && !displayMoreSignatories"
            class="displayMoreSignatories clickable"
            @click="displayMoreSignatories = true"
        >
          {{ $t('project.signed-documents.pane.SignedDocumentsFiltersPane.displayMoreSignatories') }}
        </h4>

        <h4 v-if="signatories.length > 10 && displayMoreSignatories"
            class="displayLessSignatories clickable"
            @click="displayMoreSignatories = false"
        >
          {{ $t('project.signed-documents.pane.SignedDocumentsFiltersPane.displayLessSignatories') }}
        </h4>
      </template>
    </template>
  </app-filters-drawer>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import AppDateRangePicker from '@/common/AppDateRangePicker.vue'

export default {
  name: 'SignedDocumentsFiltersPane',
  components: { AppDateRangePicker },
  data () {
    return {
      displayMoreSignatories: false,
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('signedDocuments', ['signedDocuments', 'filters']),
    datesFilter() {
      const { startDate, endDate } = this.filters
      if (startDate) {
        return endDate ? [startDate, endDate] : [startDate]
      }

      return []
    },
    signatories() {
      const array = []
      this.signedDocuments.forEach(signedDocument => {
        if (signedDocument?.mySignature) {
          if (!array.find(signatory => signatory.signerId === signedDocument.mySignature.signerId)) {
            array.push(signedDocument.mySignature)
          }
        }
        if (signedDocument?.otherSignatures?.length > 0) {
          signedDocument.otherSignatures.forEach(otherSignature => {
            if (!array.find(signatory => signatory.signerId === otherSignature.signerId)) {
              array.push(otherSignature)
            }
          })
        }
      })
      return array
    },
    shortSignatories() {
      return this.signatories.slice(0, 10)
    },
  },
  methods: {
    ...mapActions('signedDocuments', ['setFiltersStartDate', 'setFiltersEndDate', 'setFiltersSignatories']),
    onCloseRequest(source) {
      // The header button doubles as a reset here, unlike an outside interaction
      if (source === 'cancel') {
        this.resetFilters()
        return
      }
      this.closePane()
    },
    closePane() {
      this.$emit('close')
    },
    handleDatesFilterChange(value) {
      this.setFiltersStartDate(value[0] || null)
      if (value.length === 2) {
        this.setFiltersEndDate(value[1])
      } else {
        this.setFiltersEndDate(null)
      }
    },
    resetFilters() {
      this.setFiltersSignatories([])
      this.setFiltersStartDate(null)
      this.setFiltersEndDate(null)
      this.closePane()
    },
  },
}
</script>

<style scoped lang="scss">
.displayMoreSignatories:hover,
.displayLessSignatories:hover {
  color: rgb(var(--v-theme-primary));
}

:deep(.SignedDocumentsFiltersPane-checkbox) {
  i {
    font-size: 18px;
  }

  label {
    font-size: 14px;
  }
}
</style>
